import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { noteCrashDetectorRoute } from "utils/crashDetector";

// Keeps the crash detector's heartbeat record pointing at the current route.
// Must be rendered inside the Router.
export function useCrashDetectorRoute(): void {
  const location = useLocation();

  useEffect(() => {
    noteCrashDetectorRoute(location.pathname);
  }, [location.pathname]);
}
